import React from 'react';
import PropTypes from 'prop-types';
import {IconCheckboxTemplate} from 'themes/components';

const IconCheckbox = function(props) {
    return <IconCheckboxTemplate {...props} />
};

IconCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
};

export default IconCheckbox;
